export const RESTART_ON_REMOUNT = "@@saga-injector/restart-on-remount";
export const DAEMON = "@@saga-injector/daemon";
export const ONCE_TILL_UNMOUNT = "@@saga-injector/once-till-unmount";

export const DEVICE_TYPES = {
  TWIG: {
    NAME: "twig",
    FW_REGEX: /[CT]T(?<range>\d)[PW]\.(?<major>\d{2})\.(?<minor>\d{3})\.0000/,
    MIN_VERS: "5.2.001",
    MAX_VERS: "5.2.026",
  },
};

export const LEGACY_TILES_LIST = ["openAlerts"];
